import { DecisionNode, NodeOption, Trade, Urgency } from '../../../core/models/decision-tree.model';

const URGENCY_LABEL: Record<Urgency, string> = {
  notfall: 'Notfall',
  heute: 'Heute',
  diese_woche: 'Diese Woche',
  flexibel: 'Flexibel / geplant',
};

/**
 * FE preview of the summary string the server will produce. Uses the spec's
 * outputTemplate.summary with `{node_id}` and `{a|b}` fallback syntax. Walks
 * the same path as wizard-engine.walkPath. The final, authoritative summary
 * is built server-side at submit — this is purely UX for the live preview.
 */
export function buildSummaryPreview(
  trade: Trade,
  answers: Readonly<Record<string, string>>,
  urgency: Urgency | null,
): string {
  const labels: Record<string, string> = {};
  let cursor: string | null = trade.rootNodeId;
  let safety = 0;

  while (cursor && safety++ < 100) {
    const node: DecisionNode | undefined = trade.nodes[cursor];
    if (!node) break;
    if (node.type === 'summary_and_extras') break;
    if (node.type === 'info_step') {
      cursor = node.next ?? null;
      continue;
    }
    const value = answers[node.id];
    if (!value) break;
    const opt = (node.options ?? []).find((o: NodeOption) => o.value === value);
    if (!opt) break;
    labels[node.id] = opt.label;
    cursor = opt.next ?? node.next ?? null;
  }

  // No outputTemplate available on the FE DTO, so build a generic summary
  // from labels in walk-order. Backend still owns the canonical contract.
  const parts = Object.values(labels).filter(Boolean);
  if (urgency) parts.push(URGENCY_LABEL[urgency]);
  return parts.length ? `${trade.name}: ${parts.join(' · ')}` : trade.name;
}

export const URGENCY_TO_LABEL = URGENCY_LABEL;
